import './Sidebar.css'
import logo from '../../assets/images/brainyagent.svg'
import searchIcon from '../../assets/images/search.svg'
import newChatIcon from '../../assets/images/newChat.svg'
import dashboardIcon from '../../assets/images/dashboard.svg'
import fileIcon from '../../assets/images/file.svg'
import settingIcon from '../../assets/images/setting.svg'
import questionIcon from '../../assets/images/question.svg'
import logoutIcon from '../../assets/images/logout.svg'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { logout } from '../../service/authService'
import { useDispatch, useSelector } from 'react-redux'
const Sidebar = () => {
    const userAgreement = useSelector((state) => state.userAgreement);
    const {pathname} = useLocation();
    const navigateTo = (path) => {
        // dispatch(setSelectedThread(null));
    }
    return (
        <div className='sidebar'>
            
            <ul className='menu'>
                {/* <li><NavLink to={userAgreement?.isLoaded && userAgreement?.isAgreed ? '/dashboard/all-set' : (userAgreement?.isConsentSelected ? '/dashboard/consent' : '/new-user')} onClick={navigateTo}><img src={dashboardIcon} alt="dashboardIcon" />Dashboard</NavLink></li> */}
                <li><NavLink to={userAgreement.isAgreed ? '/dashboard' : '/new-user'} end onClick={navigateTo}><img src={dashboardIcon} alt="dashboardIcon" />Dashboard</NavLink></li>
                <li><NavLink to={'/dashboard/my-data'} onClick={navigateTo}><img src={fileIcon} alt="fileIcon" />My Data</NavLink></li>
                <li><NavLink to={'/dashboard/settings'} onClick={navigateTo}><img src={settingIcon} alt="settingIcon" />Integrations</NavLink></li>
                <li><NavLink to={'/help'} onClick={navigateTo}><img src={questionIcon} alt="questionIcon" />Help</NavLink></li>
            </ul>
            <div className='history'>

            </div>
            {/* <div className='logoutBtn cursor-pointer' onClick={logout}>
                <img src={logoutIcon} alt="logoutIcon" />Log Out
            </div> */}
        </div>
    )
}

export default Sidebar
